// src/pages/Utilisateurs/PrepaPhysique/components/PrepaPhysiqueAdherentCard.jsx

import React from "react";
import { FaCheckCircle, FaUser } from "react-icons/fa";

import {
  computeAdherentProgress,
  getAdherentFullName,
} from "../utils/prepaPhysiqueUtils";

import PrepaPhysiqueList from "./PrepaPhysiqueList";

export default function PrepaPhysiqueAdherentCard({
  adherent,
  exercices,
  totalBeforeFilter,
  savingKeys,
  onToggleExercise,
}) {
  const name = getAdherentFullName(adherent) || "Adhérent";

  const progressStats = computeAdherentProgress(exercices);

  return (
    <article className="overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <header className="border-b border-slate-200 bg-slate-50/80 p-4 dark:border-slate-800 dark:bg-slate-950/60">
        <div className="flex items-start justify-between gap-3">
          <div className="flex min-w-0 items-center gap-3">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-slate-950 text-white shadow-sm dark:bg-white dark:text-slate-950">
              <FaUser />
            </div>

            <div className="min-w-0">
              <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">
                Programme adhérent
              </p>

              <h3 className="mt-0.5 truncate text-lg font-bold text-slate-950 dark:text-white">
                {name}
              </h3>
            </div>
          </div>

          <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-bold text-slate-700 ring-1 ring-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700">
            <FaCheckCircle className="text-emerald-500" />
            {progressStats.done}/{progressStats.total}
          </span>
        </div>

        <div className="mt-4">
          <div className="flex items-center justify-between text-xs font-bold text-slate-500 dark:text-slate-400">
            <span>
              {progressStats.total} exercice
              {progressStats.total > 1 ? "s" : ""}
              {totalBeforeFilter !== progressStats.total && (
                <span className="ml-1 text-slate-400">
                  / {totalBeforeFilter} au total
                </span>
              )}
            </span>

            <span>{progressStats.progress}%</span>
          </div>

          <div className="mt-2 h-2 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800">
            <div
              className="h-full rounded-full bg-gradient-to-r from-emerald-400 via-sky-400 to-violet-400 transition-all duration-300"
              style={{ width: `${progressStats.progress}%` }}
            />
          </div>
        </div>
      </header>

      <div className="p-3 sm:p-4">
        <PrepaPhysiqueList
          adherent={adherent}
          exercices={exercices}
          savingKeys={savingKeys}
          onToggleExercise={onToggleExercise}
        />
      </div>
    </article>
  );
}